import {operatorViewFeatureTranslations} from '@features/operator-view'
import {optimizerFeatureTranslations} from '@features/optimizer'
import {productionPlanningFeatureTranslations} from '@features/production-planning'
import {salesForecastFeatureTranslations} from '@features/sales-forecast'
import {storageLevelsFeatureTranslations} from '@features/storage-levels'
import {
  Localization,
  combineTranslationBundles,
  loadPackageTranslations,
  setupTranslationLanguageSync,
  type LanguageCode
} from '@hconnect/common/localization-loaders'
import {uikitTranslations} from '@hconnect/uikit'
import {commonAttachmentsWidgetTranslations} from '@widgets/common-attachments'
import {energyConsumptionChartWidgetTranslations} from '@widgets/energy-consumption-chart'
import {planningScheduleChartWidgetTranslations} from '@widgets/planning-schedule-chart'
import {planningTimeControlsWidgetTranslations} from '@widgets/planning-time-controls'
import {siloFillLevelsWidgetTranslations} from '@widgets/silo-fill-levels'
import {stockCardWidgetTranslations} from '@widgets/stock-card'
import i18n from 'i18next'

const supportedLngs: LanguageCode[] = [
  'de-DE',
  'en-US',
  'en-GB',
  'ru-RU',
  'it-IT',
  'fr-FR',
  'cs-CZ',
  'hu-HU',
  'nl-NL',
  'sv-SE',
  'es-ES',
  'ro-RO',
  'no-NO',
  'pl-PL'
]

const isDev = process.env.NODE_ENV === 'development'

const loader = async (filename: string) => {
  if (isDev) {
    console.info(`Load Translation for hcem [${filename}]`)
  }
  try {
    return (await import(`./${filename}`)).default
  } catch (err) {
    if (isDev) {
      console.error(`Could not load Translation [${filename}]`, err)
    }
    return {err}
  }
}

const externalPackageTranslations = combineTranslationBundles([
  uikitTranslations,
  siloFillLevelsWidgetTranslations,
  commonAttachmentsWidgetTranslations,
  salesForecastFeatureTranslations,
  energyConsumptionChartWidgetTranslations,
  planningTimeControlsWidgetTranslations,
  planningScheduleChartWidgetTranslations,
  optimizerFeatureTranslations,
  operatorViewFeatureTranslations,
  storageLevelsFeatureTranslations,
  productionPlanningFeatureTranslations,
  stockCardWidgetTranslations
])

export const initLocalization = () => {
  void Localization({
    supportedLngs,
    backend: {loader},
    debug: isDev,
    fallbackLng: 'en-GB',
    compatibilityJSON: undefined,
    load: 'currentOnly'
  }).then(() => {
    void loadPackageTranslations(i18n, externalPackageTranslations, {debug: isDev})
    setupTranslationLanguageSync(i18n, externalPackageTranslations, {debug: isDev})
  })
}
